import React from 'react'
import Tile from '@/shared/components/Tile/Tile'
import LanguageSwitch from '@/shared/components/LanguageSwitch/LanguageSwitch'
import styles from '@/features/auth/Authorization.module.scss'

type AuthorizationProps = {
  children: React.ReactNode
}

function Authorization(props: AuthorizationProps) {
  const { children } = props
  return (
    <div className={`${styles.authorizationFormContainer}`}>
      <Tile color="white">
        <div className={`${styles.authorizationHeader}`}>
          <div id="logo" className={`${styles.logo}`} />
          <LanguageSwitch />
        </div>
        {children}
      </Tile>
    </div>
  )
}

export default Authorization
